import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTrendUp, faArrowTrendDown } from '@fortawesome/free-solid-svg-icons';

const ReadinessScoreImpact = ({ lastReadinessScoreInt, profileReadinessScoreInt, theme }) => {
  if (!lastReadinessScoreInt || lastReadinessScoreInt === profileReadinessScoreInt) {
    return null;
  }

  const isIncrease = lastReadinessScoreInt < profileReadinessScoreInt;
  const change = Math.abs(profileReadinessScoreInt - lastReadinessScoreInt);
  
  const styles = {
    container: {
      background: theme?.background?.secondary,
      borderRadius: '1rem',
      padding: '1.5rem',
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      position: 'relative',
      overflow: 'hidden',
    },
    backgroundPattern: {
      position: 'absolute',
      inset: 0,
      opacity: 0.05,
      backgroundImage: `
        radial-gradient(circle at 20% 50%, ${
          isIncrease 
            ? theme?.dashboard?.status?.correct || '#10b981'
            : theme?.dashboard?.status?.incorrect || '#ef4444'
        }, transparent 50%)
      `,
    },
    iconWrapper: {
      width: '3rem',
      height: '3rem',
      borderRadius: '0.75rem',
      background: isIncrease 
        ? theme?.primary?.green?.[500]
        : theme?.primary?.red?.[500],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    icon: {
      fontSize: '1.5rem',
      color: 'white',
    },
    content: {
      flex: 1,
    },
    changeText: {
      fontSize: '1.125rem',
      fontWeight: '600',
      color: theme?.text?.primary,
      marginBottom: '0.25rem',
    },
    detailText: {
      fontSize: '0.875rem',
      color: theme?.text?.secondary,
    },
    scoreHighlight: {
      fontWeight: '700',
      color: theme?.text?.primary,
    },
  };

  return (
    <motion.div
      style={styles.container}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      
      
      <motion.div
        style={styles.iconWrapper}
        animate={{ 
          y: isIncrease ? [0, -3, 0] : [0, 3, 0],
        }}
        transition={{ 
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <FontAwesomeIcon 
          icon={isIncrease ? faArrowTrendUp : faArrowTrendDown} 
          style={styles.icon}
        />
      </motion.div>
      
      <div style={styles.content}>
        <div style={styles.changeText}>
          Readiness Score {isIncrease ? 'Increased' : 'Decreased'} by {change}%
        </div>
        <div style={styles.detailText}>
          Your overall score changed from{' '}
          <span style={styles.scoreHighlight}>{lastReadinessScoreInt}%</span> to{' '}
          <span style={styles.scoreHighlight}>{profileReadinessScoreInt}%</span>
        </div>
      </div>
    </motion.div>
  );
};

export default ReadinessScoreImpact;